<h1>General team settings</h1>

<section id="details">
  <div class="section-title-row">
    <h2>Team details</h2>
    <tp-button (click)="openEditTeamDialog()" buttonStyle="secondary stroke" buttonId="editTeam">
      <i class="fa-light fa-pen-to-square"></i> Edit
    </tp-button>
  </div>
  <p class="tp-section-info">Configure basic team settings</p>
  <tp-properties-table>
    <tp-properties-table-row key="Team URL">
      <div class="tp-team-url-prefix">cloud.typedb.com/team/</div>{{ team.id }}
    </tp-properties-table-row>
    <tp-properties-table-row key="Team Name">{{ team.name }}</tp-properties-table-row>
    <tp-properties-table-row key="Creation Date">{{ team.createdAt | datetime }}</tp-properties-table-row>
  </tp-properties-table>
</section>

<section id="members">
  <h2 class="section-title-row">Team members</h2>
  @if (teamIsPersonal) {
    <div class="integrations-row">
      <tp-integration-card title="Enable Member Invites" faIcon="fa-thin fa-users" (click)="openEnableTeamModeModal()">
        <p>This will allow you to invite other members of your team to collaborate with you on TypeDB Cloud.</p>
      </tp-integration-card>
    </div>
  } @else {
    <p class="tp-section-info">You can invite team members on the <a [routerLink]="membersPath(team)">members page</a></p>
  }
</section>

<section id="api-tokens">
  <tp-table-toolbar [table]="apiTokens" filterGroupId="apiTokens" headerLevel="h2" tableTitle="API tokens" [actions]="[apiTokenCreationButton]"/>
  <div class="tp-section-info">
    <p>These keys allow scoped access to individual spaces through the API.</p>
    <p>Try not to keep disused keys around. If you have any suspicion that one of these may be compromised, delete it and use a new one.</p>
    <p><a href="https://typedb.com/docs/manual/cloud/api/">More about the Cloud API in TypeDB Docs</a>.</p>
  </div>
  <tp-api-tokens-table [table]="apiTokens" [rowPopupMenuItems]="apiTokensTableRowPopupMenuItems"/>
  <tp-table-paginator [table]="apiTokens"/>
</section>

<tp-delete-resource-section
  title="Danger zone"
  [display]="{ text: 'Once you delete a team, there is no going back. Please be certain.' }"
  buttonText="Delete team"
  (buttonPressed)="showContactSupportDialog()"
  buttonIconClass="fa-light fa-trash-can"
  id="danger-zone"
  headerLevel="h2"
/>
